import { atom } from "recoil";

import { persistAtom } from "@states/persist";
import { BusinessRulesInterface } from "@types";

export const businessRulesState = atom<BusinessRulesInterface | undefined>({
    key: "businessRulesState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});
